var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useContext, useEffect } from 'react';
import { useRouter, Link } from '@curi/react-dom';
import toast from 'react-hot-toast';
import { ProfileContext } from '__state/Profile';
import { updateUser, getPartyData } from 'services';
import HeaderAuth from 'components/HeaderAuth';
import './RegisterProfile.scss';
var baseClass = 'page__register-profile';
var RegisterProfile = function () {
    var router = useRouter();
    var _a = useContext(ProfileContext), profile = _a.profile, setProfile = _a.setProfile;
    var _b = useState((profile === null || profile === void 0 ? void 0 : profile.firstName) || ''), firstName = _b[0], setFirstName = _b[1];
    var _c = useState((profile === null || profile === void 0 ? void 0 : profile.lastName) || ''), lastName = _c[0], setLastName = _c[1];
    var _d = useState(''), yearGraduated = _d[0], setYearGraduated = _d[1];
    var _e = useState(''), linkedin = _e[0], setLinkedin = _e[1];
    var _f = useState(), party = _f[0], setParty = _f[1];
    useEffect(function () {
        var getParty = function () { return __awaiter(void 0, void 0, void 0, function () {
            var partySnap, partyData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getPartyData()];
                    case 1:
                        partySnap = _a.sent();
                        partyData = partySnap.data();
                        setParty(partyData);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        getParty();
    }, []);
    var updateInfo = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var userProfile, url, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    // shouldn't happen
                    if (!profile) {
                        toast.error('Something went wrong saving your profile information. Please try again or contact us.');
                        return [2 /*return*/, false];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    userProfile = __assign(__assign({}, profile), { firstName: firstName.trim(), lastName: lastName.trim(), yearGraduated: yearGraduated, linkedin: linkedin.trim() });
                    return [4 /*yield*/, updateUser(profile.id, userProfile)];
                case 2:
                    _a.sent();
                    setProfile(userProfile);
                    url = router.url({ name: "RegisterPhoto" });
                    router.navigate({ url: url });
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    if (!party) {
        return null;
    }
    return (_jsxs("div", __assign({ className: baseClass }, { children: [_jsx(HeaderAuth, { logo: party.headerImage, color: party.headerColor }, void 0), _jsx("div", __assign({ className: baseClass + "__title" }, { children: _jsx("h1", { children: "Create Your Profile" }, void 0) }), void 0), _jsxs("div", __assign({ className: baseClass + "__page-info" }, { children: [_jsx("span", { children: _jsx("b", { children: "Step 2 of 3" }, void 0) }, void 0), _jsx(Link, __assign({ name: "RegisterPhoto" }, { children: "Skip" }), void 0)] }), void 0), _jsx("div", __assign({ className: baseClass + "__form" }, { children: _jsxs("form", __assign({ onSubmit: updateInfo }, { children: [_jsxs("div", __assign({ className: "form-row" }, { children: [_jsx("label", __assign({ htmlFor: "firstName" }, { children: "First Name" }), void 0), _jsx("input", { name: "firstName", type: "text", value: firstName, onChange: function (e) { return setFirstName(e.target.value); }, required: true }, void 0)] }), void 0), _jsxs("div", __assign({ className: "form-row" }, { children: [_jsx("label", __assign({ htmlFor: "lastName" }, { children: "Last Name" }), void 0), _jsx("input", { name: "lastName", type: "text", value: lastName, onChange: function (e) { return setLastName(e.target.value); }, required: true }, void 0)] }), void 0), _jsxs("div", __assign({ className: "form-row" }, { children: [_jsx("label", __assign({ htmlFor: "yearGraduated" }, { children: "Year Graduated" }), void 0), _jsx("input", { name: "yearGraduated", type: "number", placeholder: "ex: 2006", value: yearGraduated, onChange: function (e) { return setYearGraduated(e.target.value); } }, void 0)] }), void 0), _jsxs("div", __assign({ className: "form-row" }, { children: [_jsx("label", __assign({ htmlFor: "linkedin" }, { children: "LinkedIn URL" }), void 0), _jsx("input", { name: "linkedin", type: "url", placeholder: "https://www.linkedin.com/in/username", value: linkedin, pattern: "https?://.+", onChange: function (e) { return setLinkedin(e.target.value); } }, void 0)] }), void 0), _jsx("div", __assign({ className: "form-row" }, { children: _jsx("input", { type: "submit", value: "Last Step" }, void 0) }), void 0)] }), void 0) }), void 0)] }), void 0));
};
export default RegisterProfile;
